import React from "react";
import { useContext } from "react";
import { ActiveModuleName } from '../../../mtska-frontend-app-component';
import { AppContext } from '../../contexts';
const Header = () => {

    const { currentModuleName } = useContext(AppContext);



    return (
        <header>
            <ActiveModuleName currentModuleName={currentModuleName} />
            <div className="filler"></div>
        </header>
    );
}

export default Header;